import axios from 'axios'

export default {
    getCompanyOffersById(id) {
        return axios.get('/company-offer', {
            headers: {
                'x-tenant-id': id,
            },
        })
    },

    getCompanyOffersByLocationId(locationId, id) {
        return axios.get(`/company-offer/${locationId}`, {
            headers: {
                'x-tenant-id': id,
            },
        })
    },

    getPublicCompanyOffersById(id) {
        return axios.get(`/offer/company-offers/${id}`)
    },

    getOfferById(id, isCalendarFiltered = 0) {
        return axios.get(`/offer/${id}?filterActive=${isCalendarFiltered}`)
    },

    getUserOffersByLocationId(locationId) {
        return axios.get(`/user-offer/${locationId}`)
    },

    getUserExpirationList() {
        return axios.get('/user-offer/expiration-list')
    },

    getUserOffers() {
        return axios.get('/user-offer')
    },

    createUserOffer({
        title,
        description,
        appointmentLength,
        price,
        currency,
        serviceId,
        locationId,
        reservationTimeLimitInMinutes,
        workingScheduleSlot,
        type,
    }) {
        return axios.post('/user-offer', {
            title,
            description,
            appointmentLength,
            price,
            currency,
            serviceId,
            locationId,
            reservationTimeLimitInMinutes,
            workingScheduleSlot,
            type,
        })
    },

    modifyUserOffer({
        id,
        title,
        description,
        appointmentLength,
        price,
        currency,
        serviceId,
        locationId,
        reservationTimeLimitInMinutes,
        type,
    }) {
        return axios.put(`/user-offer/${id}`, {
            title,
            description,
            appointmentLength,
            price,
            currency,
            serviceId,
            locationId,
            reservationTimeLimitInMinutes,
            type,
        })
    },

    createUserOfferCategory({ offerId, title, description, appointmentLength, price }) {
        return axios.post('/user-offer-category', {
            offerId,
            title,
            description,
            appointmentLength,
            price,
        })
    },

    modifyUserOfferCategory({ id, offerId, title, description, appointmentLength, price }) {
        return axios.put(`/user-offer-category/${id}`, {
            offerId,
            title,
            description,
            appointmentLength,
            price,
        })
    },

    createCompanyOffer({
        companyId,
        title,
        description,
        appointmentLength,
        price,
        currency,
        serviceId,
        locationId,
        reservationTimeLimitInMinutes,
        type,
    }) {
        return axios.post(
            '/company-offer',
            {
                title,
                description,
                appointmentLength,
                price,
                currency,
                serviceId,
                locationId,
                reservationTimeLimitInMinutes,
                type,
            },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    modifyCompanyOffer({
        id,
        companyId,
        title,
        description,
        appointmentLength,
        price,
        currency,
        serviceId,
        locationId,
        reservationTimeLimitInMinutes,
        workingScheduleSlot,
        type,
        cancelLimitForInitiators,
        rescheduleLimitForInitiators,
    }) {
        return axios.put(
            `/company-offer/${id}`,
            {
                title,
                description,
                appointmentLength,
                price,
                currency,
                serviceId,
                locationId,
                reservationTimeLimitInMinutes,
                workingScheduleSlot,
                type,
                cancelLimitForInitiators,
                rescheduleLimitForInitiators,
            },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    createCompanyOfferCategory({ companyId, title, description, appointmentLength, price, offerId }) {
        return axios.post(
            '/company-offer-category',
            {
                offerId,
                title,
                description,
                appointmentLength,
                price,
            },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    modifyCompanyOfferCategory({ id, offerId, companyId, title, description, appointmentLength, price }) {
        return axios.put(
            `/company-offer-category/${id}`,
            {
                offerId,
                title,
                description,
                appointmentLength,
                price,
            },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    deleteUserOffer({ id }) {
        return axios.delete(`/user-offer/${id}`)
    },

    deleteUserOfferCategory({ id }) {
        return axios.delete(`/user-offer-category/${id}`)
    },

    deleteCompanyOffer({ id, companyId }) {
        return axios.delete(`/company-offer/${id}`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    deleteCompanyOfferCategory({ id, companyId }) {
        return axios.delete(`/company-offer-category/${id}`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    extendUserOffer({ id }) {
        return axios.put(`/user-offer/extend/${id}`)
    },

    addUserAvailability({
        userId,
        offerId,
        timeline,
        startWeekDate,
        timelineTitle,
        performerId,
        moderatorIds,
        moderatorInvites,
        validFrom,
        validTo,
        bookingDaysLimit,
    }) {
        return axios.post(
            `/user-availability`,
            {
                offerId,
                timeline,
                startWeekDate,
                timelineTitle,
                performerId,
                moderatorIds,
                moderatorInvites,
                validFrom,
                validTo,
                bookingDaysLimit,
            },
            {
                headers: {
                    'x-tenant-id': userId,
                },
            },
        )
    },

    addCompanyAvailability({
        companyId,
        offerId,
        timeline,
        startWeekDate,
        timelineTitle,
        performerId,
        moderatorIds,
        moderatorInvites,
        validFrom,
        validTo,
        bookingDaysLimit,
    }) {
        return axios.post(
            `/company-availability`,
            {
                offerId,
                timeline,
                startWeekDate,
                timelineTitle,
                performerId,
                moderatorIds,
                moderatorInvites,
                validFrom,
                validTo,
                bookingDaysLimit,
            },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    getCompanyInvites(companyId, availabilityId) {
        return axios.get(`/invitation/company-filter`, {
            params: {
                availabilityId: availabilityId,
            },
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getUserInvites(availabilityId) {
        return axios.get(`/invitation/user-filter`, {
            params: {
                availabilityId: availabilityId,
            },
        })
    },

    removeInvite(id) {
        return axios.delete(`/invitation/${id}`)
    },

    findOffers(filter) {
        return axios.post(`/offer`, filter)
    },

    findOffersForMap(filter) {
        return axios.post(`/offer/map-filter`, filter)
    },

    findMostPopularServices(countryId) {
        return axios.get(`/dashboard/find-most-popular-services?countryId=${countryId}`)
    },

    getTopCompanies(countryId) {
        return axios.get(`/dashboard/top-rated-companies?countryId=${countryId}`)
    },

    getMy() {
        return axios.get(`/user-offer/mine`)
    },

    findOfferCategoriesByTerm(filter) {
        return axios.get(`/offer/quick-filter?filter=${filter}`)
    },

    getAffectedAvailabilityEvents(data) {
        return axios.put('/availability/number-of-affected-events', data)
    },

    updateCompanyAvailability(request) {
        return axios.put('/company-availability/update-time-line', request, {
            headers: {
                'x-tenant-id': request.companyId,
            },
        })
    },

    updateUserAvailability(request) {
        return axios.put('/user-availability/update-time-line', request)
    },

    uploadPhotos({ id, files }) {
        return Promise.all(
            files.map((file) => {
                return axios
                    .post(
                        `/photo/offer/${id}`,
                        {
                            photo: file.base64File.split(`,`)[1],
                            type: file.type,
                        },
                        {
                            onUploadProgress: function (progressEvent) {
                                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                file.progress = percentCompleted
                            },
                        },
                    )
                    .then((res) => {
                        file.isUploaded = true
                        file.isUploading = false
                        file.file.id = res.id
                    })
                    .catch((error) => {
                        file.isUploading = false
                        file.error = true
                        throw error
                    })
            }),
        )
    },

    removePhoto(id) {
        return axios.delete(`/photo/${id}`)
    },

    setMainPhoto(id) {
        return axios.put(`/photo/offer-main/${id}`)
    },

    getFavorites() {
        return axios.get(`/favourite`)
    },

    addToFavorites(offerId) {
        return axios.post('/favourite', { offerId })
    },

    removeFromFavorites(offerId) {
        return axios.delete(`/favourite/${offerId}`)
    },

    getCompanyDiscounts(companyId) {
        return axios.post(
            '/company-discount/discount-list',
            {},
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    createCompanyDiscount(request, companyId) {
        return axios.post('/company-discount', request, {
            headers: {
                'x-tenant-id': Number(companyId),
            },
        })
    },

    updateCompanyDiscount(request, id, companyId) {
        return axios.put(`/company-discount/${id}`, request, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    deleteCompanyDiscount(id, companyId) {
        return axios.delete(`/company-discount/${id}`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    getUserDiscounts() {
        return axios.post('/user-discount/discount-list')
    },

    createUserDiscount(request) {
        return axios.post('/user-discount', request)
    },

    updateUserDiscount(request, id) {
        return axios.put(`/user-discount/${id}`, request)
    },

    deleteUserDiscount(id) {
        return axios.delete(`/user-discount/${id}`)
    },
}
